"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_1 = require("react");

var _1 = require(".");

var react_2 = require("./react");

exports.default = function (_a, pluginOptions) {
  var element = _a.element;
  return React.createElement(Login, {
    pluginOptions: pluginOptions
  }, element);
};

var Login = function Login(_a) {
  var children = _a.children,
      pluginOptions = _a.pluginOptions;

  var _b = useFakeToken(),
      fakeToken = _b[0],
      setFakeToken = _b[1];

  var realToken = useLogin(pluginOptions);
  var token = fakeToken || realToken;
  if (!token) return null;
  return React.createElement(react_2.setFakeTokenContext.Provider, {
    value: setFakeToken
  }, React.createElement(react_2.tokenContext.Provider, {
    value: token
  }, children));
};

function useLogin(pluginOptions) {
  var _this = this;

  var _a = react_1.useState(null),
      token = _a[0],
      setToken = _a[1];

  var loginAndRefreshLoop = function loginAndRefreshLoop() {
    return __awaiter(_this, void 0, void 0, function () {
      var loginResult, loginResult_1, loginResult_1_1, token_1, e_1_1;

      var e_1, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , _1.login(pluginOptions)];

          case 1:
            loginResult = _b.sent();
            _b.label = 2;

          case 2:
            _b.trys.push([2, 7, 8, 13]);

            loginResult_1 = __asyncValues(loginResult);
            _b.label = 3;

          case 3:
            return [4
            /*yield*/
            , loginResult_1.next()];

          case 4:
            if (!(loginResult_1_1 = _b.sent(), !loginResult_1_1.done)) return [3
            /*break*/
            , 6];
            token_1 = loginResult_1_1.value;
            setToken(token_1);
            _b.label = 5;

          case 5:
            return [3
            /*break*/
            , 3];

          case 6:
            return [3
            /*break*/
            , 13];

          case 7:
            e_1_1 = _b.sent();
            e_1 = {
              error: e_1_1
            };
            return [3
            /*break*/
            , 13];

          case 8:
            _b.trys.push([8,, 11, 12]);

            if (!(loginResult_1_1 && !loginResult_1_1.done && (_a = loginResult_1.return))) return [3
            /*break*/
            , 10];
            return [4
            /*yield*/
            , _a.call(loginResult_1)];

          case 9:
            _b.sent();

            _b.label = 10;

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            if (e_1) throw e_1.error;
            return [7
            /*endfinally*/
            ];

          case 12:
            return [7
            /*endfinally*/
            ];

          case 13:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  react_1.useEffect(function () {
    if (sessionStorage.getItem('@devsisters/passport:skip-login') === 'true') return;
    loginAndRefreshLoop();
  }, []);
  return token;
}

function useFakeToken() {
  var key = '@devsisters/passport:fake-token';

  var _a = react_1.useState(null),
      fakeToken = _a[0],
      setFakeToken = _a[1];

  react_1.useEffect(function () {
    var payload = sessionStorage.getItem(key);
    if (!payload) return;

    var _a = JSON.parse(payload),
        content = _a.content,
        clientId = _a.clientId;

    setFakeToken(_1.FakeToken.create(content, clientId));
  }, []);
  react_1.useEffect(function () {
    if (!fakeToken) return sessionStorage.removeItem(key);
    sessionStorage.setItem(key, JSON.stringify(fakeToken));
  }, [fakeToken]);
  return [fakeToken, setFakeToken];
}